<template>
  <!-- 年份范围 -->
  <date-picker
    v-if="['yearrange'].includes(this.dateType)"
    ref="main"
    class="l-time"
    :format="myformat"
    :value-format="myformat"
    :placeholder="placeholder"
    :startPlaceholder="startPlaceholder"
    :endPlaceholder="endPlaceholder"
    :readonly="readonly"
    :disabled="disabled"
    :editable="editable"
    :clearable="clearable"
    :size="size"
    :type="dateType"
    :key="dateType"
    :align="align"
    :rangeSeparator="rangeSeparator"
    :default-Value="defaultValue"
    :unlink-panels="unlinkPanels"
    v-model="value2"
    :picker-options="['yearrange'].includes(this.dateType) ? pickerOptions : {}"
  >
  </date-picker>

  <!-- 其它类型 -->
  <el-date-picker
    v-else
    style="width: 240px"
    ref="main"
    class="l-time"
    :format="myformat"
    :valueFormat="myformat"
    :placeholder="placeholder"
    :startPlaceholder="startPlaceholder"
    :endPlaceholder="endPlaceholder"
    :readonly="readonly"
    :disabled="disabled"
    :editable="editable"
    :clearable="clearable"
    :size="size"
    :type="dateType"
    :align="align"
    :rangeSeparator="rangeSeparator"
    :defaultValue="defaultValue"
    :unlink-panels="unlinkPanels"
    v-model="value2"
    :picker-options="
      ['datetimerange', 'daterange', 'monthrange', 'yearrange'].includes(
        this.dateType
      )
        ? pickerOptions
        : {}
    "
  >
  </el-date-picker>
</template>

<script>
import DatePicker from "./date-picker.js";
import dayjs from "dayjs";

export default {
  components: { DatePicker },
  name: "l-date",
  props: {
    value: {},
    placeholder: String,
    startPlaceholder: String,
    endPlaceholder: String,
    readonly: Boolean,
    disabled: Boolean,
    editable: Boolean,
    clearable: { type: Boolean, default: true },
    size: { type: String, default: "mini" },
    dateType: { type: String, default: "date" },
    align: String,
    rangeSeparator: { type: String, default: "-" },
    defaultValue: Date,
    isDefault: { type: Boolean, default: false },
    format: String,
    selectableRange: [String, Array],
    unlinkPanels: { type: Boolean, default: true },
  },
  data() {
    return {
      pickerOptions: { shortcuts: [] },
    };
  },
  mounted() {
    this.getShortcuts();
    this.SetDefaultDate();
  },
  computed: {
    value2: {
      get() {
        if (this.isRange) {
          if (this.$validatenull(this.value)) return ["", ""];
          return this.value.split(" - ");
        } else {
          if (this.$validatenull(this.value)) return this.value;
          return this.value.replace("T", " ");
        }
      },
      set(newValue) {
        if (this.isRange) {
          if (this.$validatenull(newValue)) {
            this.$emit("input", "");
          } else {
            this.$emit(
              "input",
              `${newValue[0]} ${this.rangeSeparator} ${newValue[1]}`
            );
          }
        } else {
          this.$emit("input", newValue);
        }
        this.$emit("change", newValue);
      },
    },
    myformat() {
      const map = {
        datetime: "yyyy-MM-dd HH:mm:ss",
        datetimerange: "yyyy-MM-dd HH:mm",
        daterange: "yyyy-MM-dd",
        monthrange: "yyyy-MM",
        yearrange: "yyyy",
      };
      return this.format || map[this.dateType] || "yyyy-MM-dd";
    },
    isRange() {
      return ["datetimerange", "daterange", "monthrange", "yearrange"].includes(
        this.dateType
      );
    },
  },
  methods: {
    // 默认赋值近三个月
    SetDefaultDate() {
      if (this.isRange && this.isDefault) {
        const end = dayjs().format("YYYY-MM-DD HH:mm:ss");
        const start = dayjs()
          .subtract(3, "month")
          .subtract(1, "day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.value2 = [start, end];
      }
    },

    getShortcuts() {
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      const monthFormat = "YYYY-MM";
      const yearFormat = "YYYY";

      if (this.dateType === "datetimerange" || this.dateType === "daterange") {
        this.pickerOptions.shortcuts = [
          {
            text: "过去七天",
            onClick(picker) {
              const now = dayjs();
              const start = now.subtract(6, "day").format(dateFormat);
              picker.$emit("pick", [
                new Date(start),
                new Date(now.format(dateFormat)),
              ]);
            },
          },
          {
            text: "过去一个月",
            onClick(picker) {
              const now = dayjs();
              const start = now
                .subtract(1, "month")
                .subtract(1, "day")
                .format(dateFormat);
              picker.$emit("pick", [
                new Date(start),
                new Date(now.format(dateFormat)),
              ]);
            },
          },
          {
            text: "过去三个月",
            onClick(picker) {
              const now = dayjs();
              const start = now
                .subtract(3, "month")
                .subtract(1, "day")
                .format(dateFormat);
              picker.$emit("pick", [
                new Date(start),
                new Date(now.format(dateFormat)),
              ]);
            },
          },
          {
            text: "未来七天",
            onClick(picker) {
              const now = dayjs();
              const end = now.add(6, "day").format(dateFormat);
              picker.$emit("pick", [
                new Date(now.format(dateFormat)),
                new Date(end),
              ]);
            },
          },
          {
            text: "未来一个月",
            onClick(picker) {
              const now = dayjs();
              const end = now
                .add(1, "month")
                .subtract(1, "day")
                .format(dateFormat);
              picker.$emit("pick", [
                new Date(now.format(dateFormat)),
                new Date(end),
              ]);
            },
          },
          {
            text: "未来三个月",
            onClick(picker) {
              const now = dayjs();
              const end = now
                .add(3, "month")
                .subtract(1, "day")
                .format(dateFormat);
              picker.$emit("pick", [
                new Date(now.format(dateFormat)),
                new Date(end),
              ]);
            },
          },
          {
            text: "今年上半年",
            onClick(picker) {
              const year = dayjs().year();
              const start = dayjs(`${year}-01-01`).format(dateFormat);
              const end = dayjs(`${year}-07-01`)
                .subtract(1, "day")
                .format(dateFormat);
              picker.$emit("pick", [new Date(start), new Date(end)]);
            },
          },
          {
            text: "今年下半年",
            onClick(picker) {
              const year = dayjs().year();
              const start = dayjs(`${year}-07-01`).format(dateFormat);
              const end = dayjs(`${year + 1}-01-01`)
                .subtract(1, "day")
                .format(dateFormat);
              picker.$emit("pick", [new Date(start), new Date(end)]);
            },
          },
          {
            text: "年至今",
            onClick(picker) {
              const year = dayjs().year();
              const start = dayjs(`${year}-01-01`).format(dateFormat);
              const end = dayjs().format(dateFormat);
              picker.$emit("pick", [new Date(start), new Date(end)]);
            },
          },
          {
            text: "月至今",
            onClick(picker) {
              const start = dayjs().startOf("month").format(dateFormat);
              const end = dayjs().format(dateFormat);
              picker.$emit("pick", [new Date(start), new Date(end)]);
            },
          },
        ];
      } else if (this.dateType === "monthrange") {
        this.pickerOptions.shortcuts = [
          {
            text: "本月",
            onClick(picker) {
              const start = dayjs().startOf("month").format(monthFormat);
              picker.$emit("pick", [new Date(start), new Date(start)]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = dayjs()
                .subtract(1, "month")
                .startOf("month")
                .format(monthFormat);
              picker.$emit("pick", [new Date(start), new Date(start)]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const start = dayjs().subtract(2, "month").format(monthFormat);
              const end = dayjs().format(monthFormat);
              picker.$emit("pick", [new Date(start), new Date(end)]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const start = dayjs().subtract(5, "month").format(monthFormat);
              const end = dayjs().format(monthFormat);
              picker.$emit("pick", [new Date(start), new Date(end)]);
            },
          },
        ];
      } else if (this.dateType === "yearrange") {
        this.pickerOptions.shortcuts = [
          {
            text: "去年",
            onClick(picker) {
              const start = dayjs().subtract(1, "year").format(yearFormat);
              picker.$emit("pick", [new Date(start), new Date(start)]);
            },
          },
          {
            text: "今年",
            onClick(picker) {
              const start = dayjs().format(yearFormat);
              picker.$emit("pick", [new Date(start), new Date(start)]);
            },
          },
        ];
      }
    },
  },
};
</script>
